export default __webpack_public_path__ + "static/media/engine.2211c806.svg";